import { render, staticRenderFns } from "./MiniCartDrawerAccessories.vue?vue&type=template&id=7b2c1f04&scoped=true&"
import script from "./MiniCartDrawerAccessories.vue?vue&type=script&lang=ts&"
export * from "./MiniCartDrawerAccessories.vue?vue&type=script&lang=ts&"
import style0 from "./MiniCartDrawerAccessories.vue?vue&type=style&index=0&id=7b2c1f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2c1f04",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesMiniCartDrawerAccessory: require('/var/www/packages/theme/components/molecules/MiniCartDrawer/MiniCartDrawerAccessory.vue').default})
